import { CheckmarkFilled } from '@carbon/icons-react';
import classNames from 'classnames';
import { Spin } from 'antd';

const IMPORT_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  DUPE_FOUND: 'DUPE_FOUND',
  FAILURE: 'FAILURE',
  RETRYABLE: 'RETRYABLE',
};

export const getImportStatusValue = (importStatus) => {
  if (!importStatus) return null;
  if (typeof importStatus === 'string') return importStatus;
  return importStatus.importStatus || importStatus.status || null;
};

const getConfig = (status) => {
  switch (status) {
    case IMPORT_STATUS.SUCCESS:
      return {
        bg: 'bg-green-50',
        border: 'border-green-200',
        text: 'text-green-700',
        label: 'Successfully imported to Legacy',
        icon: CheckmarkFilled,
      };
    case IMPORT_STATUS.DUPE_FOUND:
      return {
        bg: 'bg-yellow-50',
        border: 'border-yellow-300',
        text: 'text-yellow-800',
        label: 'Duplicate record found in Legacy',
        icon: null,
      };
    case IMPORT_STATUS.FAILURE:
      return {
        bg: 'bg-red-50',
        border: 'border-red-200',
        text: 'text-red-700',
        label: 'Import to Legacy failed.',
        icon: null,
      };
    case IMPORT_STATUS.RETRYABLE:
      return {
        bg: 'bg-red-50',
        border: 'border-red-200',
        text: 'text-red-700',
        label: 'Legacy import failed. Please try again.',
        icon: null,
      };
    case IMPORT_STATUS.IN_PROGRESS:
      return {
        bg: 'bg-gray-50',
        border: 'border-gray-200',
        text: 'text-gray-600',
        label: 'Syncing with Legacy.',
        icon: null,
        spinner: true,
      };
    default:
      return null;
  }
};

const ProviderImportStatusBanner = ({ importStatus, className }) => {
  const config = getConfig(getImportStatusValue(importStatus));

  if (!config) return null;

  const StatusIcon = config.icon;

  return (
    <div className={classNames('rounded-lg p-3 border-solid border text-sm', config.bg, config.border, className)}>
      <div className={classNames('flex items-center gap-1.5 font-medium', config.text)}>
        {config.spinner && <Spin size="small" className="mr-1" />}
        <span>{config.label}</span>
        {StatusIcon && <StatusIcon className="w-4 h-4" />}
      </div>
    </div>
  );
};

export default ProviderImportStatusBanner;
